var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".adbd7b84-5c93-4ac8-a88c-7d8436a7c542{fill:#fff;}.ae7be11b-e25b-4bc5-a19f-b0e2a71a6f0b{fill:none;stroke:#fff;stroke-miterlimit:10;}")),React.createElement("g",{"id":"f4487689-3f0f-4c3f-a831-f9e8a9b1f17b","data-name":"Layer 2","key":1},React.createElement("g",{"id":"b500a50c-216b-4d72-97d3-4765eecb492b","data-name":"Layer 1"},[React.createElement("path",{"className":"adbd7b84-5c93-4ac8-a88c-7d8436a7c542","d":"M11,15H9V9h2Zm0-8H9V5h2Z","key":0}),React.createElement("circle",{"className":"ae7be11b-e25b-4bc5-a19f-b0e2a71a6f0b","cx":"10","cy":"10","r":"9.5","key":1})]))]);
}

Info.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Info;

Info.default = Info;
